import { Show, createMemo, type Component } from 'solid-js';
import { heldIn } from '~/stores/portfolio-store';

// "You own this one."
//
// Every search in this app lists the whole pool, and until now none of them said
// which rows were already yours. That turns reading a screener into a memory
// test — the one fact you have that the table does not is the one you have to
// keep in your head while scanning it.
//
// A dot rather than a word. It sits inside a search result beside a symbol, a
// name and a yield, and there is no room for a fifth column; more to the point,
// this is a yes/no that only matters on the rows where it is yes, and a "No"
// printed on the other fifteen would be louder than the answer.
//
// The accounts are on the title, because which account is a real second question
// — the same fund in a TFSA and in a margin account are taxed differently — and
// it costs nothing to answer for anyone who wants it.

/** Reads "TFSA", "TFSA and Margin", "TFSA, Margin and Cash". */
const listed = (labels: string[]): string => (labels.length < 2 ? (labels[0] ?? '') : `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`);

export const HeldMark: Component<{ symbol: string; class?: string }> = (props) => {
    const accounts = createMemo(() => heldIn(props.symbol));

    return (
        <Show when={accounts().length > 0}>
            <span
                class={`inline-block size-1.5 shrink-0 rounded-full bg-foreground ${props.class ?? ''}`}
                title={`Held in ${listed(accounts().map((a) => a.label))}`}
                aria-label={`Held in ${listed(accounts().map((a) => a.label))}`}
            />
        </Show>
    );
};

export default HeldMark;
